import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'ramda/src/isEmpty';
import Icon from '@components/@core/Icon';

function CustomInput(props) {
    const { value, onClick, placeholder } = props;
    return (
        <button className="custom-input" onClick={onClick}>
            {isEmpty(value) ? <>{placeholder}</> : <>{value}</>}
            <Icon name="fas fa-angle-down mx-1" color="#969faa" size={15} />
        </button>
    );
}

CustomInput.propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.string,
};

CustomInput.defaultProps = {
    onClick: () => {},
    value: '',
    placeholder: 'Select',
};

export default memo(CustomInput);
